import React from 'react';
import {useDispatch} from "react-redux";
import {NavLink} from "react-router-dom";
import {CATALOG_ROUTE, PICTURES_PATH} from "../utils/consts";
import {parseImg} from "../utils/parseImg";

const ProductCard = ({product}) => {
    const aImg = parseImg(product.img) || [];
    return (
        <div className="col-lg-4 col-md-4 col-12">
            <article className="single_product">
                <figure itemScope itemType="https://schema.org/Product">
                    <div className="product_thumb">
                        <NavLink className="primary_img" to={`${CATALOG_ROUTE}/${product.id}`}>
                            <img
                                itemProp="image"
                                src={`${PICTURES_PATH}product/${aImg[0]}`}
                                alt={product.title}
                            />
                        </NavLink>
                    </div>
                    <div className="product_content grid_content">
                        <div className="product_price_rating">
                            <NavLink to={`${CATALOG_ROUTE}/${product.id}`}>
                                <h4 itemProp="name" className="product_name">{product.title}</h4>
                                <div className="product_sort">{product.sort}</div>
                                <div className="product_size">{product.size}</div>
                            </NavLink>
                            <div className="price_box" itemProp="offers" itemScope itemType="https://schema.org/Offer">
                                <span className="current_price" itemProp="price">{product.price}</span>
                                <meta itemProp="priceCurrency" content="RUB" />
                                <link itemProp="availability" href="https://schema.org/InStock" />
                                <link itemProp="url" href={`${CATALOG_ROUTE}/${product.id}`} />
                            </div>
                        </div>
                    </div>
                </figure>
            </article>
        </div>
    );
};

export default ProductCard;